import { Injectable, OnDestroy, inject } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { AuthService } from './auth.service';

/**
 * Starts a sign-in.
 *
 * This used to embed the `<zero-account>` widget and run the whole flow inside
 * this page. It now hands off to the hosted auth page, which is where the flow
 * lives for every relying party — including us. That makes the dashboard an
 * ordinary integration rather than a special case, so anything broken in the
 * login our customers use is broken in ours first.
 */
@Injectable({
  providedIn: 'root',
})
export class AuthLibService implements OnDestroy {
  private authService = inject(AuthService);
  private router = inject(Router);

  private destroy$: Subject<boolean> = new Subject<boolean>();

  start(): void {}

  stop(): void {}

  /**
   * Named for the modal it used to open. It is a full navigation now: the flow
   * ends in a redirect back from the provider, and the session cookie has to
   * arrive on a top-level request.
   */
  showAuthModal(): void {
    const current = this.router.url;
    this.authService.login(current.startsWith('/login') ? '/apps' : current);
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }
}
